import React from "react";
import { useNavigate } from 'react-router-dom';

function BackButton(props) {


    const navigate  = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    }

    return (
        <button type="button" className="btn btn-outline-primary bigButton backButton" style={{"opacity": "0.8"}} onClick={handleBackClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                 className="bi bi-arrow-return-left buttonImage" viewBox="0 0 16 16">
                <path fillRule="evenodd"
                      d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>
            </svg>Späť
        </button>
    )
}

export default BackButton
